import {LeaderboardUser} from '@dms/api/settings';

import {getOperationGroupId} from './getOperationGroupId';
import {PayPerUseOperationColumn} from './getOperationTypeColumns';
import {isHiddenOperation} from './isHiddenOperation';

/** Per-group sum across all users (for the leaderboard Total row). */
export const getLeaderboardColumnTotals = (
  users: LeaderboardUser[],
  columns: PayPerUseOperationColumn[]
): Record<string, number> => {
  const totals = columns.reduce<Record<string, number>>((accumulator, column) => {
    accumulator[column.key] = 0;
    return accumulator;
  }, {});

  users.forEach((user) => {
    user.byOperationType.forEach((operation) => {
      if (isHiddenOperation(operation)) {
        return;
      }
      const groupId = getOperationGroupId(operation);
      if (groupId in totals) {
        totals[groupId] += operation.count;
      }
    });
  });

  return totals;
};
